import {motion} from "framer-motion";
import React, {useState, useEffect} from "react";
import axios from 'axios';
import './Stylesheets/Global.css';
import './Stylesheets/Portfolio.css';
import Wave from '../Decorations/Contacts/test5.svg';
import wave from '../Decorations/Contacts/contact-bg.svg';
import PortfolioDesign from '../Decorations/Home/SVG/PortfolioDesign.svg';
import PortfolioTitle from '../Decorations/Home/SVG/Portfolio.svg';
import PortfolioBGImage from '../Decorations/Home/SVG/PortfolioIntroBg.svg';
import {Category} from '../Interfaces/Category';
import { url } from "inspector";

// Note: Perhaps we should implement a mapper for the portfolio items, so we can easily add new items without changing the code.
// May require us to adjust the DB Context for backend.

export default function Portfolio(){

    const backend_url = process.env.REACT_APP_BACKEND_URL;

    const [categories, setCategories] = useState<Category[]>([]);

    const [isLoading, setIsLoading] = useState(true)

    // Retrieve all category types
    useEffect(() => {
        axios.get(`${backend_url}/Blog/GetCategories`)
        .then( res => setCategories(res.data['content']))
        .finally(() => 
            setIsLoading(false)
        )

    },[])

    const renderContent = () => {

        if (categories.length === 0) {
            return (
                <h2>No Works available at the moment</h2>
            )
        }else{

            return (
                <>
     
                    { categories.map( (category) => (
                        <a id={category.categoryName} href={`Gallery/${category.categoryName}`}className={'portfolio-selection-option-link'}>
                            <div className={'portfolio-selection-option'}>
                                <h3 className={'portfolio-option-title'}>{category.categoryName}</h3>
                                <img className={"option-img"} src={require(`../Icons/Portfolio/${category.categoryId}.svg`)}></img>
                            </div>
                        </a>
                    ))
                    }


                </>
            )
        }
    }

    return(
        <>                              
            <div className={'portfolio-top-intro-div'}> 
                {/* <img className={'portfolio-intro-bg'} src={PortfolioBGImage} /> */}
                {/* <h1 id={'txt-design'} className={'portfolio-intro-text'}><span id={"txt-design"}>Design</span> <span id={"txt-portfolio"}>Portfolio</span></h1> */}
                <span style={{width: "100%", height: "auto", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#00000089"}}>
                    <h1 className={'portfolio-intro-text'}>Design Portfolio</h1>
                </span>
                
                {/* <h1 id={'txt-portfolio'} className={'portfolio-intro-text'}></h1> */}
            </div>

            <div className={'portfolio-selection-div'}>
                <div className={'portfolio-selection-options-div'}>
                    {isLoading ? <h1>Loading Options</h1> : renderContent()}
                </div>
            </div>
        
        </>
        
    )

}
